/**
 * Shared variable resolution helpers used by both templateBindings and templateStyles.
 * Extracted to avoid circular imports between those modules.
 */

export function getVariablesFromContext(context: Record<string, unknown>): Record<string, unknown> {
  return (
    (context?.templateResolvedVariables as Record<string, unknown> | undefined) ||
    ((context?.template as Record<string, unknown>)?.variables as Record<string, unknown> | undefined) ||
    {}
  );
}

export function resolveVariablePath(variables: Record<string, unknown>, expr: string): unknown {
  const parts = expr.split(".");
  let value: unknown = variables;
  for (const part of parts) {
    if (value && typeof value === "object" && part in (value as Record<string, unknown>)) {
      value = (value as Record<string, unknown>)[part];
      continue;
    }
    return undefined;
  }
  return value;
}
